export const appPageId = 'app-page';
